import Strategy from './Strategy'

import {
  getBrowserLocale,
  getLocalStorageLocale,
  setLocalStorageLocale,
} from '../helpers/browser.helpers'
import { I18nStrategy, Locale } from '../model'

interface BrowserStrategyProps {
  root: Window
}

class BrowserStrategy extends Strategy implements I18nStrategy {
  root: Window
  locale: Locale | undefined

  constructor(props: BrowserStrategyProps) {
    super()
    this.root = props.root
    this.init()
  }

  init() {
    this.locale = getLocalStorageLocale(this.root) || getBrowserLocale(this.root)
  }

  getLocale() {
    return this.locale
  }

  setLocale(locale: Locale) {
    setLocalStorageLocale(this.root, locale)
    this.locale = locale
    this.update()
  }
}

export default BrowserStrategy
